import { render, staticRenderFns } from "./TournamentIcon.vue?vue&type=template&id=005265b3"
import script from "./TournamentIcon.vue?vue&type=script&lang=ts"
export * from "./TournamentIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports